<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
    <div class="layout-footer">
        {{ t('settings.poweredBy') }}
        <a href="https://digibite.it" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">DigiBite</a>
    </div>
</template>
